module.exports = __webpack_public_path__ + "static/media/white-wave.c345cf2b.svg";